// permissions.js
export function can(permission, userPermissions) {
 // console.info("match");
 // console.info(permission);
 // console.info(userPermissions);
  return userPermissions.includes(permission);
}
